<template>
  <div class="ey-cell">
    <div class="title">{{title}}</div><span v-if="colon">:</span><div class="value" >{{value}}</div>
  </div>
</template>

<script>
export default {
  name: 'cell',
  props: {
    colon: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    value: {
      type: String
    }
  }
}
</script>

<style lang="stylus" scoped>
.ey-cell
  display: flex
  min-width: 50%
  .title
    min-width:100px;
    font-size:26px;
    font-weight:400;
    color:rgba(102,102,102,1)
    opacity:1;
    text-align-last:justify;
    text-align:justify;
  span
    font-size:30px;
    font-weight:400;
    color:rgba(102,102,102,1)
  .value
    font-size:26px;
    font-weight:400;
    color: #333333
    opacity:1;
    padding-left: 12px
</style>
